














import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import VNumberPicker from "./VNumberPicker.vue";

export const TIME_FORMAT = "HH:mm";

@Component({
  components: {
    VNumberPicker,
  },
})
export default class TimePicker extends Vue {
  @Prop() readonly value!: string;
  hours = 0;
  minutes = 0;

  @Watch("value")
  onValueChange(value: string) {
    this.updateHoursAndMinutes(value);
  }

  @Watch("time")
  onTimeChange(value: string) {
    this.$emit("input", value);
  }

  created() {
    this.updateHoursAndMinutes(this.value);
  }

  get time(): string {
    const time = this.$moment();
    time.hours(this.hours);
    time.minutes(this.minutes);

    return time.format(TIME_FORMAT);
  }

  updateHoursAndMinutes(value: string) {
    const time = value || "00:00";
    const date = this.$moment(time, TIME_FORMAT);

    this.hours = date.hours();
    this.minutes = date.minutes();
  }
}
